export { default as SerpBulkStockAdjustmentSlot } from './SerpBulkStockAdjustmentSlot';
